import React, { useState, useEffect } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import axios from 'axios'
import V2Layout from '../components/V2Layout'

const API = ''

function stripHtml(html) {
    if (!html) return ''
    return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 200)
}

const SearchResultsScreen = () => {
    const [searchParams] = useSearchParams()
    const query = searchParams.get('q') || ''
    const [results, setResults] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!query.trim()) { setResults(null); return }
        setLoading(true)
        axios.get(`${API}/api/search`, { params: { q: query.trim() } })
            .then(r => setResults(r.data))
            .catch(() => setResults(null))
            .finally(() => setLoading(false))
    }, [query])

    const totalResults = results
        ? (results.products?.length || 0) + (results.news?.length || 0) + (results.jobs?.length || 0)
        : 0

    return (
        <V2Layout pageClass="pfc-search">
            <section className="pfc-page-hero" style={{ paddingBottom: '2rem' }}>
                <div className="pfc-page-hero-inner">
                    <p className="v2-section-label">Search Results</p>
                    <h1 className="pfc-page-hero-title" style={{ fontSize: 'clamp(1.5rem, 3vw, 2.5rem)' }}>
                        {query ? `Results for "${query}"` : 'Search'}
                    </h1>
                </div>
            </section>

            <section style={{ padding: '2rem 2.5rem 4rem', maxWidth: 900, margin: '0 auto' }}>
                {loading && <p style={{ color: 'var(--v2-text2)' }}>Searching...</p>}

                {!loading && results && totalResults === 0 && (
                    <p style={{ color: 'var(--v2-text2)', fontSize: '1rem' }}>
                        No results found for "{query}". Try a different search term.
                    </p>
                )}

                {/* Products */}
                {results?.products?.length > 0 && (
                    <div className="search-result-group">
                        <h2 className="search-result-heading">
                            Products ({results.products.length})
                        </h2>
                        <div className="search-result-list">
                            {results.products.map(p => (
                                <Link key={p.id} to={`/products/${p.id}`} className="search-result-item">
                                    <div style={{ fontSize: '0.9375rem', fontWeight: 600, color: 'var(--v2-text)', marginBottom: '0.25rem' }}>
                                        {p.model || p.modelNumber || p.sku || ''}{p.name ? ` - ${p.name}` : ''}
                                    </div>
                                    {p.category_name && <span style={{ fontSize: '0.75rem', color: 'var(--v2-primary)', fontWeight: 600 }}>{p.category_name}</span>}
                                    {p.description && <p style={{ fontSize: '0.8125rem', color: 'var(--v2-text2)', margin: '0.25rem 0 0', lineHeight: 1.5 }}>{stripHtml(p.description)}</p>}
                                </Link>
                            ))}
                        </div>
                    </div>
                )}

                {/* News */}
                {results?.news?.length > 0 && (
                    <div className="search-result-group">
                        <h2 className="search-result-heading">
                            News ({results.news.length})
                        </h2>
                        <div className="search-result-list">
                            {results.news.map(n => (
                                <Link key={n.id} to={`/news/${n.id}`} className="search-result-item">
                                    <div style={{ fontSize: '0.9375rem', fontWeight: 600, color: 'var(--v2-text)' }}>{n.title}</div>
                                    {n.created_at && <span style={{ fontSize: '0.75rem', color: 'var(--v2-text3)' }}>{new Date(n.created_at).toLocaleDateString()}</span>}
                                </Link>
                            ))}
                        </div>
                    </div>
                )}

                {/* Jobs */}
                {results?.jobs?.length > 0 && (
                    <div className="search-result-group">
                        <h2 className="search-result-heading">
                            Careers ({results.jobs.length})
                        </h2>
                        <div className="search-result-list">
                            {results.jobs.map(j => (
                                <Link key={j.id} to="/careers" className="search-result-item">
                                    <div style={{ fontSize: '0.9375rem', fontWeight: 600, color: 'var(--v2-text)', marginBottom: '0.25rem' }}>{j.title}</div>
                                    <span style={{ fontSize: '0.75rem', color: 'var(--v2-text2)' }}>{[j.department, j.location, j.type].filter(Boolean).join(' · ')}</span>
                                </Link>
                            ))}
                        </div>
                    </div>
                )}
            </section>
        </V2Layout>
    )
}

export default SearchResultsScreen
